import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion, useScroll, useTransform, useSpring, useMotionValue } from 'framer-motion';
import { TextReveal, MagneticButton } from '../../common/AnimationUtils';

import styles from '../styles/HeroSection.module.css';

const HeroSection = () => {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start start", "end start"]
    });

    const y = useTransform(scrollYProgress, [0, 1], [0, 150]);
    const opacity = useTransform(scrollYProgress, [0, 0.5], [1, 0]);

    // Mouse parallax effect
    const mouseX = useMotionValue(0);
    const mouseY = useMotionValue(0);

    const handleMouseMove = (e) => {
        const { clientX, clientY } = e;
        const { innerWidth, innerHeight } = window;
        const x = (clientX / innerWidth - 0.5) * 20; // Move range -10 to 10
        const y = (clientY / innerHeight - 0.5) * 20;
        mouseX.set(x);
        mouseY.set(y);
    };

    const springX = useSpring(mouseX, { stiffness: 50, damping: 20 });
    const springY = useSpring(mouseY, { stiffness: 50, damping: 20 });

    return (
        <section ref={ref} className={styles.hero} onMouseMove={handleMouseMove}>
            <motion.div
                className={styles.content}
                style={{ y, opacity, x: springX, rotateX: springY, rotateY: springX }}
            >
                <div className={styles.titleWrapper}>
                    <h1 className={styles.title}>
                        <TextReveal text="Unlock the Power of" delay={0.1} style={{ display: "inline" }} />
                        <br />
                        <span className={styles.gradientText}>
                            <TextReveal text="AI Agents & LLMs" delay={0.5} inline={true} />
                        </span>
                    </h1>
                </div>

                <motion.p
                    className={styles.subtitle}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 1.2, ease: "easeOut" }}
                >
                    Chat with top models, integrate tools, and build autonomous agents that work for you.
                    The next generation of AI interaction is here.
                </motion.p>

                <motion.div
                    className={styles.ctaGroup}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 1.4, ease: "easeOut" }}
                >
                    <MagneticButton>
                        <Link to="/register" className={styles.primaryButton}>
                            Get Started Free
                        </Link>
                    </MagneticButton>
                    <MagneticButton>
                        <Link to="/login" className={styles.secondaryButton}>
                            Log in
                        </Link>
                    </MagneticButton>
                </motion.div>
            </motion.div>
        </section>
    );
};

export default HeroSection;
